import React from 'react';
import Cookie from 'ui/legal/cookie.mdx';
import InvisibleBox from 'ui/components/common/dumb/InvisibleBox';
import { useTranslation } from 'react-i18next';
import inMainScreen from 'ui/components/hocs/inMainScreen';

const CookiePolicy: React.FC = () => {
  const { t } = useTranslation(['policies']);
  return (
    <InvisibleBox>
      <InvisibleBox.Row>
        <InvisibleBox.Heading>{t('policies:cookiePolicy')}</InvisibleBox.Heading>
      </InvisibleBox.Row>
      <InvisibleBox.Row>
        <Cookie />
      </InvisibleBox.Row>
    </InvisibleBox>
  );
};

export default inMainScreen(CookiePolicy);
